<template>
  <q-select
    :model-value="modelValue"
    :options="filteredRoles"
    option-value="id"
    label="Role"
    :loading="isLoading"
    :map-options="!object"
    v-bind="$attrs"
    @update:model-value="select"
  >
    <template v-slot:option="scope">
      <q-item
        v-bind="scope.itemProps"
      >
        <q-item-section>
          <q-item-label>{{ scope.opt.name }}</q-item-label>
          <q-item-label caption>{{ scope.opt.description }}</q-item-label>
        </q-item-section>
      </q-item>
    </template>
    <template v-slot:selected-item>
      {{ selectedText }}
    </template>
  </q-select>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import _ from 'lodash';
import { Role } from '@/type';
import { HasTaskMixin } from '@/mixins';
import repository from './roleRepository';

interface Data {
  roles: Role[],
  task: Promise<Role[]>|null,
}

export default defineComponent({
  emits: ['update:modelValue'],
  mixins: [HasTaskMixin],
  props: {
    accountType: {
      type: Number,
      required: true,
    },
    modelValue: [Number, Object as () => Role],
    object: {
      type: Boolean,
      default: false,
    },
    exclude: {
      type: Array,
      default: () => [],
    },
  },
  data(): Data {
    return {
      roles: [],
      task: null,
    };
  },
  computed: {
    filteredRoles(): Role[] {
      return this.roles.filter(r => !this.exclude.includes(r.type));
    },
    selectedRole(): Role|undefined {
      if (_.isObject(this.modelValue)) return this.modelValue;
      return this.filteredRoles.find(r => this.modelValue === r.id);
    },
    selectedText(): string {
      return this.selectedRole ? this.selectedRole.name : '';
    },
  },
  methods: {
    load() {
      this.task = repository.findAll(this.accountType);
      this.task.then((roles: Role[]) => {
        this.roles = roles;
      });
    },
    select(role: Role|null) {
      let value:Role|number|null = role;
      if (role) {
        value = (this.object) ? role : role.id;
      }
      this.$emit('update:modelValue', value);
    },
  },
  created() {
    this.load();
  },
});
</script>
